'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var TextParts = require('../common/TextParts');
var styleHelper = require('../../helper/styleHelper');
var _ = require('underscore');

/**
 * 水平花括号
 */
var HCurly = React.createClass({
  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  _doPaint: function () {


    this.requestID = window.requestAnimationFrame(function () {
      var canvasDom = ReactDOM.findDOMNode(this.refs.canvas);
      var graphics;
      var clientWidth;
      var clientHeight;
      var lineWidth = 1;
      var offset = lineWidth/2;
      var c;
      var cl;
      var cr;
      if(!canvasDom){
        return;
      }
      graphics = canvasDom.getContext('2d');
      clientWidth = canvasDom.clientWidth;
      clientHeight = canvasDom.clientHeight;
      c = Math.round(clientWidth/2);
      cl = c - 7;
      cr =  c + 7;
      graphics.clearRect(0, 0, clientWidth, clientHeight);

      graphics.lineWidth = lineWidth;
      graphics.strokeWidth = lineWidth;
      graphics.strokeStyle = styleHelper.getBackgroundColor(this.props);

      if (this.isDirTop) {

        graphics.moveTo(offset, offset);
        graphics.arcTo(offset,6-offset,5-offset,6-offset,5);


        graphics.lineTo(cl, 6 - offset);
        graphics.lineTo(c, this.curlyHeight);
        graphics.lineTo(cr, 6 - offset);

        graphics.lineTo(clientWidth - 5 + offset, 6 - offset);
        graphics.arcTo(clientWidth -  offset, 6 -offset,clientWidth - offset,offset,5);

      } else {
        graphics.moveTo(offset, clientHeight - offset);
        graphics.arcTo(offset,clientHeight - 6 + offset,5 - offset,clientHeight - 6 + offset,5);


        graphics.lineTo(cl, clientHeight - 6 + offset);
        graphics.lineTo(c, clientHeight - this.curlyHeight);
        graphics.lineTo(cr, clientHeight - 6 + offset);

        graphics.lineTo(clientWidth - 5 + offset, clientHeight - 6 + offset);

        graphics.arcTo(clientWidth - offset, clientHeight - 6 + offset,clientWidth - offset,clientHeight -  offset,5);
      }

      graphics.stroke();

    }.bind(this));

  },

  componentDidUpdate: function () {

    // TODO: 此次出调用绘制时，会导致整体花括号颜色变深，比较奇怪？？？
    this._doPaint();
  },

  componentDidMount: function () {
    this._doPaint();
  },

  render: function () {
    this.curlyHeight = 15;
    this.isDirTop = this.props.direction == appTypes.HCurlyDirection.TOP;
    var canvasTop;

    var canvasStyle;
    var textStyle;
    var selfH = styleHelper.getHeight(this.props);
    var tprops = _.extend({},this.props);
    delete tprops.currentH;
    tprops.h = selfH - this.curlyHeight - 3;

    if (this.isDirTop) {
      canvasTop = 0;
    } else {
      canvasTop = selfH - this.curlyHeight;
    }

    canvasStyle = {
      left: 0,
      top: canvasTop,
      height: this.curlyHeight,
      position: 'absolute',
      zIndex:0
    };

    textStyle = {
      left: 0,
      top: this.isDirTop ? this.curlyHeight + 3 : 0,
      width: '100%',
      height: selfH - this.curlyHeight - 3,
      position: 'absolute',
      zIndex : 1
    };


    return (<div className="component-Base" >
      <canvas ref='canvas'
              style={canvasStyle}
              width={styleHelper.getWidth(this.props)}
              height={this.curlyHeight}
      />

      <TextParts {...tprops}
        partStyle={textStyle}
        textWordWrap={true}
        textVAlign={this.isDirTop ? appTypes.VertAlign.TOP : appTypes.VertAlign.BOTTOM}
        textAlign={appTypes.HoriAlign.CENTER}
      />

    </div>);
  },
});

module.exports = HCurly;




// WEBPACK FOOTER //
// ./src/views/Components/HCurly.jsx